import React from "react";
import _ from "lodash";
import { useOutletContext } from "react-router-dom";
import {
  Button,
  SIZE,
  COLOR,
  VARIANT,
} from "@metacrm/metacrm-material-ui/dist/Button";
import { useNavigate } from "react-router-dom";
import { parseCustomDomainUrl } from "features/helpers/utils";
import { useIntl } from "react-intl";
import { Box } from "@mui/material";

const IntegrationSuccess = ({
  img,
  title,
  description,
  navigateSettingBtnText,
  isNavigateSetting = true,
  isNavigateHome = true,
  btnVariant = VARIANT.OUTLINED,
}) => {
  const [entityName, isCustomDomain] = useOutletContext();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  return (
    <div className="column" style={{ height: "calc(100vh - 60px)" }}>
      <div className="fade-up">
        {img}
        <Box textAlign="center">
          <div className="lgTitle">
            {title ??
              formatMessage({ id: "popup.success.title.integration" }) + " 🎉"}
          </div>
          <div className="description">
            {description ?? "Let’s start to serve your users via MetaCRM!"}
          </div>
        </Box>
      </div>
      <div style={{ margin: "32px auto" }} className="fade-up-more">
        {isNavigateSetting && (
          <Button
            variant={btnVariant}
            color={COLOR.SECONDARY}
            size={SIZE.XL}
            style={{ marginRight: 8, width: 160 }}
            onClick={() => {
              navigate(
                parseCustomDomainUrl(
                  isCustomDomain,
                  entityName,
                  "/settings/general/integration"
                )
              );
            }}
          >
            {navigateSettingBtnText ??
              formatMessage({ id: "global.btn.backSetting" })}
          </Button>
        )}
        {isNavigateHome && (
          <Button
            color={COLOR.SECONDARY}
            onClick={() => {
              navigate(parseCustomDomainUrl(isCustomDomain, entityName, "/"));
            }}
            size={SIZE.XL}
            style={{ width: 160 }}
          >
            {formatMessage({ id: "global.btn.letsStart" })}
          </Button>
        )}
      </div>
    </div>
  );
};

export default IntegrationSuccess;
